import { render, staticRenderFns } from "./MyAccountPassword.vue?vue&type=template&id=f52ea2ce&"
import script from "./MyAccountPassword.vue?vue&type=script&lang=js&"
export * from "./MyAccountPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports